import { updateIssueTeaser, updateIssueFilter, updateYearFilter, updateSelectedYearFilter, updateNewsletterIssueFilter, updateNewsletterIssueTeaser } from "./ArtikelVerbleibendUpdate.js";
import { getIntersectingElements, getNonIntersectingElements } from "./helper.js";

import contentTracker from "./InhaltGelesen.js";

document.addEventListener('DOMContentLoaded', heftDetailAusgabenCount());
document.addEventListener('htmx:afterSettle', heftDetailAusgabenCount());

document.addEventListener('DOMContentLoaded', heftUebersichtTeaserCount());
document.addEventListener('htmx:afterSettle', heftUebersichtTeaserCount());

document.addEventListener('DOMContentLoaded', updateHeftUebersichtJahrFilter());
document.addEventListener('htmx:afterSettle', updateHeftUebersichtJahrFilter());

document.addEventListener('htmx:afterSettle', newsletterDetailAusgabenCount());
document.addEventListener('DOMContentLoaded', newsletterDetailAusgabenCount());

document.addEventListener('htmx:afterSettle', updateNewsletterUebersichtJahrFilter());
document.addEventListener('DOMContentLoaded', updateNewsletterUebersichtJahrFilter());

document.addEventListener('htmx:afterSettle', updateNewsletterUebersichtTeaserCount());
document.addEventListener('DOMContentLoaded', updateNewsletterUebersichtTeaserCount());


// Page navigation vor/zurück knopf Artikel markieren
window.addEventListener('pageshow', (event) => {
    if (event.eventPhase == 2 && String(window.performance.getEntriesByType("navigation")[0].type) == "back_forward") {
        heftDetailAusgabenCount();
        heftUebersichtTeaserCount();
        updateHeftUebersichtJahrFilter();
        newsletterDetailAusgabenCount();
        updateNewsletterUebersichtJahrFilter();
        updateNewsletterUebersichtTeaserCount();
    }
});


//
// Hier werden die noch zu lesenden Artikel berechnet und angezeigt
// Alle Funktionnen die das updaten und anzeigen von noch zu lesenden Artikeln betreffen sind hier zu finden
// z.B. Heft Detail Ausgaben übersicht (linke seite) noch zu lesende Artikel
//

/**
 * @description Einstiegspunkt zum aktuallisieren von noch ungelesenen Artikeln in Heft Detail ansicht, Onload und update
 * @param articles_read
 */
export function heftDetailAusgabenCount(articles_read = null) {
    const ausgaben = document.querySelectorAll("li[id^=filter_ausgabe_");

    if (ausgaben.length < 1) { return; }

    if (articles_read !== null) {
        updateHeftDetailAusgabenCount(ausgaben, articles_read);
    } else {
        contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
            if (articles_read == null) { return; }

            updateHeftDetailAusgabenCount(ausgaben, articles_read);
        });
    }
}

/**
 * @description Berechne ungelesene Artikel in Ausgabe für Filter und Aktuallisere Zahl
 * @param ausgaben
 * @param articles_read
 */
function updateHeftDetailAusgabenCount(ausgaben, articles_read) {
    ausgaben.forEach(ausgabe => {
        let heft_artikel_ids = JSON.parse(ausgabe.dataset.articleids);
        const parts = ausgabe.id.split('_');
        const heft_id = parts[parts.length - 1];

        let artikel_count_max = ausgabe.dataset.articles ? ausgabe.dataset.articles : ausgabe.dataset.articlecount;

        if (heft_artikel_ids == null || heft_artikel_ids.length < 1) {
            return;
        }

        let heft_artikel_read_count = getIntersectingElements(articles_read, heft_artikel_ids).length;
        updateIssueFilter(heft_id, artikel_count_max - heft_artikel_read_count);
    });
}

/**
 * @description Einstiegspunkt zum aktuallisieren von noch ungelesenen Artikeln in Heft übersichts Seite, Onload und update
 * @param articles_read
 */
export function heftUebersichtTeaserCount(articles_read = null) {
    const teaser = document.querySelectorAll("div[id^=heftausgabe_teaser_");

    if (teaser.length < 1) { return; }

    if (articles_read !== null) {
        updateHeftUebersichtTeaserCount(teaser, articles_read);
    } else {
        contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
            if (articles_read == null) { return; }

            updateHeftUebersichtTeaserCount(teaser, articles_read);
        });
    }
}

/**
 * @description Berechne ungelesene Artikel in Ausgabe für Teaser und Aktuallisere Zahl
 * @param teaser
 * @param articles_read
 */
function updateHeftUebersichtTeaserCount(teaser, articles_read) {
    teaser.forEach(singleTeaser => {
        let heft_artikel_ids = JSON.parse(singleTeaser.dataset.articleids);
        const parts = singleTeaser.id.split('_');
        const heft_id = parts[parts.length - 1];

        let artikel_count_max = singleTeaser.dataset.articlecount;

        if (heft_artikel_ids == null || heft_artikel_ids.lenght < 1) {
            return;
        }

        let heft_artikel_read_count = getIntersectingElements(articles_read, heft_artikel_ids).length;
        updateIssueTeaser(heft_id, artikel_count_max - heft_artikel_read_count);
    });
}

/**
 * @description Berechne ungelesene Hefte in Jahren für Filter und Aktuallisiere Zahl
 * @param teaser
 * @param articles_read
 */
function updateHeftUebersichtJahrFilter() {
    let jahrUngelesene = document.querySelectorAll("span[id^=jahr_ungelesene_");

    if (jahrUngelesene.length < 1) { return; }

    contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
        if (articles_read == null) { return; }
        jahrUngelesene.forEach(jahr => {
            let hefte = JSON.parse(jahr.dataset.articleids);
            let hefteKeys = Object.keys(hefte);
            let anzahlHefte = hefteKeys.length;
            hefteKeys.forEach(heftID => {
                let artikelAnzahl = hefte[heftID].length;
                let geleseneArtikelAnzahl = getIntersectingElements(articles_read, hefte[heftID]).length;
                if (artikelAnzahl - geleseneArtikelAnzahl == 0) {
                    anzahlHefte = anzahlHefte - 1;
                }
            });

            if (jahr.id.includes("ausgewaehlt")) {
                updateSelectedYearFilter(jahr, anzahlHefte);
            } else {
                updateYearFilter(jahr, anzahlHefte);
            }
        });
    });
}

/**
 * @param articles_read
 */
export function newsletterDetailAusgabenCount(articles_read = null) {
    const ausgaben = document.querySelectorAll("li[id^=newsletterausgabe-filter-ausgabe-");

    if (ausgaben.length < 1) { return; }

    if (articles_read !== null) {
        updateNewsletterDetailAusgabenCount(ausgaben, articles_read);
    } else {
        contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
            if (articles_read == null) { return; }

            updateNewsletterDetailAusgabenCount(ausgaben, articles_read);
        });
    }
}

/**
 * @param ausgaben
 * @param articles_read
 */
function updateNewsletterDetailAusgabenCount(ausgaben, articles_read) {
    ausgaben.forEach(ausgabe => {

        if (ausgabe.dataset.articleids == undefined || ausgabe.dataset.articleids == null) {
            return;
        }

        let ausgabe_artikel_ids = JSON.parse(ausgabe.dataset.articleids);
        const parts = ausgabe.id.split('-');
        const ausgabe_id = parts[parts.length - 1];

        let artikel_count_max = ausgabe.dataset.articles ? ausgabe.dataset.articles : ausgabe.dataset.articlecount;

        if (ausgabe_artikel_ids == null || ausgabe_artikel_ids.lenght < 1) {
            return;
        }

        let newsletter_artikel_read_count = getIntersectingElements(articles_read, ausgabe_artikel_ids).length;
        updateNewsletterIssueFilter(ausgabe_id, artikel_count_max - newsletter_artikel_read_count);
    });
}

/**
 * @param teaser
 * @param articles_read
 */
function updateNewsletterUebersichtJahrFilter() {
    let jahrUngelesene = document.querySelectorAll("span[id^=jahr-ungelesene-");

    if (jahrUngelesene.length < 1) { return; }

    contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
        if (articles_read == null) { return; }
        jahrUngelesene.forEach(jahr => {
            let newsletter = JSON.parse(jahr.dataset.articleids);
            let newsletterKeys = Object.keys(newsletter);
            let anzahlnewsletter = newsletterKeys.length;
            newsletterKeys.forEach(newsletterID => {
                let artikelAnzahl = newsletter[newsletterID].length;
                let geleseneArtikelAnzahl = getIntersectingElements(articles_read, newsletter[newsletterID]).length;
                if (artikelAnzahl > 0 && artikelAnzahl - geleseneArtikelAnzahl == 0) {
                    anzahlnewsletter = anzahlnewsletter - 1;
                }
            });

            if (jahr.id.includes("ausgewaehlt")) {
                updateSelectedYearFilter(jahr, anzahlnewsletter);
            } else {
                updateYearFilter(jahr, anzahlnewsletter);
            }
        });
    });
}

function updateNewsletterUebersichtTeaserCount() {
    const teaser = document.querySelectorAll("div[id^=newsletterausgabe_teaser");

    if (teaser.length < 1) { return; }

    contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
        if (articles_read == null) { return; }

        teaser.forEach(singleTeaser => {
            let newsletter_artikel_ids = JSON.parse(singleTeaser.dataset.newsletterArticles);
            const parts = singleTeaser.id.split('_');
            const newsletter_id = parts[parts.length - 1];

            let artikel_count_max = newsletter_artikel_ids.length;

            if (newsletter_artikel_ids == null || newsletter_artikel_ids.lenght < 1 || artikel_count_max < 1) {
                return;
            }

            let newsletter_artikel_read_count = getIntersectingElements(articles_read, newsletter_artikel_ids).length;
            updateNewsletterIssueTeaser(newsletter_id, artikel_count_max - newsletter_artikel_read_count);
        });
    });

}
